export enum SupportedLanguage {
	English = 'en',
	Spanish = 'es',
	French  = 'fr',
	German  = 'de'
}
